import { Event } from '@livecontrol/scheduler/model';
import { store } from '../../../store';
import type { UseEventsHook } from './use-events';
import { useEvents } from './use-events';
import { useUntitledEvents } from './use-untitled-events';

import Phase = Event.Phase;

export const useLiveEvents: UseEventsHook & { untitledEvents?: ReturnType<typeof useUntitledEvents>['untitledEvents'] } = (filters) => {
  const { untitledEvents } = useUntitledEvents();

  /*
   * No onUpdate handler, for the same reason `use-my-events.ts` dropped its own: evicting on every
   * subscription message raced with the websocket's own fetch of those ids. An `onUpdateEvent` landing
   * after the fetch wrote the event deleted it from the cache again, and the row vanished until some
   * later batch happened to mention it — two events going live together, one of them gone for a minute.
   * The websocket refetches what changed and evicts whatever stopped matching the filter.
   */
  const { events, ...results } = useEvents(filters, {
    status: Phase.Live
  });

  const { environment } = store.getState();

  return {
    ...results,
    events: events?.filter((v) => !environment.DEMO_CUSTOMER_IDS.includes(Number(v.client?.cid))),
    untitledEvents
  };
};
